jQuery(document).ready(function ($) {
  $(".clique-publicidade").on("click", function (e) {
    //e.preventDefault();
    var url = url_base + "acoes/app/publicidades/contador.php";
    $.ajax({
      url: url,
      type: "POST",
      data: {
        publicidade_id: $(this).data("id"),
      },
      success: function (data) {
        //console.log(data);
      },
      error: function (xhr, type, exception) {
        console.log("erro publicidades");
      },
    });
  });
});
